var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 9.43509C8.26311 9.43509 8.02622 9.34782 7.8392 9.1608L0.271177 1.59278C-0.0903924 1.23121 -0.0903924 0.632747 0.271177 0.271177C0.632747 -0.0903924 1.23121 -0.0903924 1.59278 0.271177L8.5 7.1784L15.4072 0.271177C15.7688 -0.0903924 16.3673 -0.0903924 16.7288 0.271177C17.0904 0.632747 17.0904 1.23121 16.7288 1.59278L9.1608 9.1608C8.97378 9.34782 8.73689 9.43509 8.5 9.43509Z",
    fill: "#0C1525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectArrowDown);
export default __webpack_public_path__ + "static/media/select-arrow-down.d0140eb9ff1d32f6f1a1e8b78aebd1eb.svg";
export { ForwardRef as ReactComponent };